import { render, staticRenderFns } from "./GlobalPartnersProductDetailView.vue?vue&type=template&id=f94031e4&scoped=true"
import script from "./GlobalPartnersProductDetailView.vue?vue&type=script&lang=js"
export * from "./GlobalPartnersProductDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94031e4",
  null
  
)

export default component.exports